import { NavLink } from "react-router-dom";
import CheckBox from "../../components/controls/Checkbox/CheckBox";
import DateTimePicker from "../../components/controls/DateTimePicker/DateTimePicker";
import FindAccount from "../../components/controls/FindAccount/FindAccount";
import FormCommand from "../../components/controls/FormCommand/FormCommand";
import TextBox from "../../components/controls/TextBox/TextBox";
import "./settingspage.css";
import Frame from "../../components/controls/Frame/Frame";
import GridView from "../../components/controls/GridView/GridView";
import { useState } from "react";
import financialPeriodService from "../../services/financialPeriodService";
import FormModal from "../../components/controls/FormModal";

export interface SettingsPageProps {}

function SettingsPage(props: SettingsPageProps) {
  const [showFinancialYear, setShowFinancialYear] = useState(false);
  const [showHolidayForm, setShowHolidayForm] = useState(false);

  return (
    <>
      <div className="row">
        <div className="col">
          <Frame>
            <div className="row">
              <div className="col-3">
                <ul
                  id="settings-menu"
                  className="nav nav-pills tabs-left flex-column"
                  role="tablist"
                >
                  <li className="nav-item">
                    <a
                      href="/"
                      className="nav-link active"
                      id="nav-home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-home"
                      type="button"
                    >
                      General Settings
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      href="/"
                      className="nav-link"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-profile"
                      type="button"
                    >
                      SMS Settings
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      href="/"
                      className="nav-link"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-contact"
                      type="button"
                    >
                      Loan Settings
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      href="/"
                      className="nav-link"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-disabled"
                      type="button"
                    >
                      Transaction Settings
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      href="/"
                      className="nav-link"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-holiday"
                      type="button"
                    >
                      Holiday Settings
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      href="/"
                      className="nav-link"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-financial-period"
                      type="button"
                    >
                      Financial Period
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      href="/"
                      className="nav-link"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-locations"
                      type="button"
                    >
                      Locations
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-9">
                <div className="tab-content" id="nav-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="nav-home"
                    role="tabpanel"
                    aria-labelledby="nav-home-tab"
                    tabIndex={0}
                  >
                    <fieldset className="mt-3">
                      <legend>
                        <h5>Account Settings</h5>
                      </legend>
                      <div className="row">
                        <div className="col">
                          <TextBox
                            type="number"
                            minValue={10}
                            maxValue={20}
                            id="accountNoLength"
                            text="Account Number Length"
                          />
                          <CheckBox
                            id="autoApproveAccounts"
                            text="Auto Approve Accounts"
                            type="switchbox"
                          />
                        </div>
                        <div className="col">
                          <TextBox
                            id="accountOpeningTemplateMessage"
                            text="Account Opening Template Message"
                            isMultiLine={true}
                          />
                        </div>
                      </div>

                      <hr />
                      <h5>Income/Expense Settings</h5>
                      <div className="row">
                        <div className="col">
                          <FindAccount
                            id="interestInSuspenseAccount"
                            text="Interest in Suspense Account"
                          />
                        </div>
                        <div className="col">
                          <FindAccount
                            id="interestExpenseAccount"
                            text="Interest Expense Account"
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <FindAccount
                            id="interestIncomeAccount"
                            text="Interest IncomeAccount"
                          />
                        </div>
                        <div className="col">
                          <FindAccount
                            id="interestExpenseAccount"
                            text="Interest Expense Account "
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <FindAccount
                            id="incomeAccount"
                            text="Income Account"
                          />
                        </div>
                        <div className="col">
                          <FindAccount
                            id="expenseAccount"
                            text="Expense Account "
                          />
                        </div>
                      </div>
                    </fieldset>

                    <FormCommand />
                  </div>
                  <div
                    className="tab-pane fade"
                    id="nav-profile"
                    role="tabpanel"
                    aria-labelledby="nav-profile-tab"
                    tabIndex={1}
                  >
                    <fieldset className="mb-3 mt-3">
                      <div className="row">
                        <div className="col">
                          <TextBox
                            text="SMS Balance"
                            id="smsBalance"
                            disabled
                          />
                        </div>
                        <div className="col">
                          <TextBox
                            id="costPerSMS"
                            text="SMS Charge Per Unit"
                            type="number"
                          />
                        </div>
                        <div className="col">
                          <TextBox
                            id="smsSenderId"
                            text="SMS SenderID"
                            type="text"
                          />
                        </div>
                        <div className="col">
                          <div style={{ marginTop: ".45rem" }}>
                            <CheckBox
                              id="maskAccountNoInSMS"
                              text="Mask AccountNo"
                            />
                          </div>
                          <TextBox id="maxCharacter" text="" value="*" />
                        </div>
                      </div>
                    </fieldset>

                    <fieldset>
                      <div className="row">
                        <div className="col-3">
                          <CheckBox
                            id="enableSMSAlert"
                            text="Enable SMS Alert"
                            type="switchbox"
                          />
                          <CheckBox
                            id="enableEmailAlert"
                            text="Enable Email Alert"
                            type="switchbox"
                          />
                        </div>
                        <div className="col-9">
                          <CheckBox
                            id="enableBirthDayMessages"
                            text="Enable Birthday messages"
                            type="switchbox"
                          />
                          <TextBox
                            id="birthDayMessageTemplate"
                            text="Birthday Message Template"
                          />
                        </div>
                      </div>
                    </fieldset>

                    <FormCommand />
                  </div>
                  <div
                    className="tab-pane fade"
                    id="nav-contact"
                    role="tabpanel"
                    aria-labelledby="nav-contact-tab"
                    tabIndex={2}
                  >
                    <fieldset className="mb-3 mt-3">
                      <legend>
                        <h5>Narration settings</h5>
                      </legend>
                      <TextBox
                        id="creditNarration"
                        text="Default Narration"
                        placeHolder="BEING FACILITY GRANTED TO..."
                      />

                      <div style={{ marginTop: "10px" }}>
                        <CheckBox
                          id="diverInterestToSuspenseAccountIfLoanExpired"
                          text="Divert interest to suspense account if loan has expired"
                          type="switchbox"
                        />
                      </div>
                    </fieldset>
                    <hr />
                    <fieldset>
                      <legend>
                        <h5>Notification Settings</h5>
                      </legend>
                      <div className="row">
                        <div className="col-4">
                          <CheckBox
                            id="enableLoanRepaymentReminder"
                            text="Enable Loan Repayment Reminder"
                            type="switchbox"
                          />
                          <DateTimePicker
                            id="loanRepaymentReminderDeliveryDate"
                            type="time"
                            text="Delivery Time of day"
                          />
                        </div>
                      </div>
                    </fieldset>

                    <FormCommand />
                  </div>
                  <div
                    className="tab-pane fade"
                    id="nav-disabled"
                    role="tabpanel"
                    aria-labelledby="nav-disabled-tab"
                    tabIndex={3}
                  >
                    <fieldset className="mt-3">
                      <div className="row mb-3">
                        <div className="col">
                          <TextBox
                            id="depositNarration"
                            text="Enter default deposit narration"
                            placeHolder="Default Deposit Narration"
                          />
                        </div>
                        <div className="col">
                          <TextBox
                            id="withdrawalNarrataion"
                            text="Enter default withrawal narration"
                            placeHolder="Default Withdrawal Narration"
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <CheckBox
                          id="forceCapitalLettersForNarration"
                          text="Use capital letters for narration"
                          type="switchbox"
                        />
                      </div>
                    </fieldset>
                    <hr />

                    <fieldset>
                      <div className="row">
                        <div className="col">
                          <CheckBox
                            id="enableTransactionTypeChecking"
                            text="Enable Transaction type checking"
                            type="switchbox"
                          />
                          <CheckBox
                            id="enableTransactionTypeCheckingForUsers"
                            text="Enable Transaction Type checking for Users"
                            type="switchbox"
                          />
                          <CheckBox
                            id="enableTransactionLimitCheckingForUsers"
                            text="Enable Transaction Limit Checking For Users"
                            type="switchbox"
                          />
                        </div>
                        <div className="col">
                          <CheckBox
                            id="autoApproveTransactions"
                            text="Automatically approve transactions"
                            type="switchbox"
                          />

                          <CheckBox
                            id="autoPrintReceipts"
                            text="Print receipts for transactions"
                            type="switchbox"
                          />
                        </div>
                      </div>
                    </fieldset>

                    <hr />
                    <fieldset>
                      <legend>
                        <small>Approval configuration</small>
                      </legend>

                      <NavLink
                        to={"configure-approvals"}
                        className={"btn btn-outline-secondary btn-sm"}
                      >
                        Configure approvals
                      </NavLink>
                    </fieldset>

                    <FormCommand />
                  </div>
                  <div
                    className="tab-pane fade"
                    id="nav-holiday"
                    role="tabpanel"
                    aria-labelledby="nav-holiday"
                    tabIndex={4}
                  >
                    <h5>Holiday(s)</h5>

                    <GridView
                      showSearchBar={true}
                      showAddButton={true}
                      onAddRecord={() => setShowHolidayForm(true)}
                    ></GridView>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="nav-financial-period"
                    role="tabpanel"
                    aria-labelledby="nav-financial-period"
                    tabIndex={5}
                  >
                    <h5>Financial Year/Period</h5>
                    <GridView
                      showSearchBar={true}
                      showAddButton={true}
                      onAddRecord={() => setShowFinancialYear(true)}
                    ></GridView>
                  </div>

                  <div
                    className="tab-pane fade"
                    id="nav-locations"
                    role="tabpanel"
                    aria-labelledby="nav-locations"
                    tabIndex={6}
                  >
                    <h5>Locations</h5>
                    <GridView
                      context="Locations"
                      showSearchBar={true}
                      showAddButton={true}
                      onAddRecord={() => setShowFinancialYear(true)}
                    ></GridView>
                  </div>
                </div>
              </div>
            </div>
          </Frame>
        </div>
      </div>

      {showFinancialYear && (
        <FormModal onClose={() => setShowFinancialYear(false)}>
          <FinancialPeriodForm />
        </FormModal>
      )}

      {showHolidayForm && (
        <FormModal onClose={() => setShowHolidayForm(false)}>
          <HolidayForm />
        </FormModal>
      )}
    </>
  );
}

export default SettingsPage;

export type FinancialPeriodFormProps = {};

type FinancialPeriod = {
  name?: string;
  startDate?: Date | undefined;
  endDate?: Date | undefined;
};

export function FinancialPeriodForm(props: FinancialPeriodFormProps) {
  const [financicalPeriod, setFinancialPeriod] = useState<FinancialPeriod>({});

  return (
    <div className="row">
      <div className="col">
        <TextBox
          id="financialYear"
          text="Financial Year Name"
          value={financicalPeriod?.name}
          onChange={(e) => {
            setFinancialPeriod({
              ...financicalPeriod,
              name: e.currentTarget.value,
            });
          }}
        />

        <div className="row">
          <div className="col">
            <TextBox
              id="startDate"
              text="Start Date"
              type="date"
              onChange={(e) =>
                setFinancialPeriod({
                  ...financicalPeriod,
                  startDate: e.currentTarget.valueAsDate,
                })
              }
            />
          </div>
          <div className="col">
            <TextBox
              id="endDate"
              text="End Date"
              type="date"
              onChange={(e) =>
                setFinancialPeriod({
                  ...financicalPeriod,
                  startDate: e.currentTarget.valueAsDate,
                })
              }
            />
          </div>
        </div>

        <FormCommand
          onSubmit={async () => {
            const res = await financialPeriodService.createOrUpdatePeriod({
              name: financicalPeriod?.name,
              fromDate: financicalPeriod?.startDate,
              toDate: financicalPeriod?.endDate,
            });

            alert(res.message);
            if (res.status && res.data) {
              // TODO: redirect here to do something else
            }

            return res;
          }}
        />
      </div>
    </div>
  );
}

export function HolidayForm() {
  return (
    <div>
      <TextBox id="holidayName" text="Holiday Name" />
      <div className="row">
        <div className="col">
          <DateTimePicker type={"date"} id={"startDate"} text={"Start Date"} />
        </div>
        <div className="col">
          <DateTimePicker type={"date"} id={"endDate"} text={"End Date"} />
        </div>

        <FormCommand />
      </div>
    </div>
  );
}

export function LocationForm() {
  return (
    <div>
      <div className="form-field">
        <TextBox id="locationName" text="Location Name" />
      </div>

      <div className="form-field">
        <CheckBox id="chkCanHaveVault" text="Create Vault" />
      </div>

      <FormCommand />
    </div>
  );
}

export function LocationTypeForm() {
  return (
    <div>
      <TextBox id="locationTypeName" text="Location Type Name" />
      <FormCommand />
    </div>
  );
}
